export { default as MaterialIcon } from './components/MaterialIcon.svelte';
export { icons } from './icons';
